import React from "react";
import UserList from "../userList";
import { getRole, ROLES } from "../../utils/roles";
import DashboardUsersByApplication from "./DashboardUsersByApplication";

const DashboardUsers = ({ loginStatus }) => {
  if (getRole(loginStatus) === ROLES.ADMIN) {
    return <DashboardUsersByApplication />;
  }

  return (
    <div className="dashboard-card dashboard-card--embedded">
      <UserList embedded />
    </div>
  );
};

export default DashboardUsers;
